import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { validatable } from 'components/utils';

class DropDownChonCoQuanTiepNhan extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        require={this.props.require}
        selectedValue={this.props.selectedValue}
        className={this.props.className}
        label="Cơ quan tiếp nhận"
        options={this.props.data}
        keyName='coQuanQuanLyId'
        valueName='ten'
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        name={this.props.name}/>
    )
  }
}

DropDownChonCoQuanTiepNhan.defaultProps = {
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: ''
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.coQuanTiepNhan
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonCoQuanTiepNhan));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-choncoquantiepnhan.jsx